var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "list-group list-group-flush" },
    [
      _c("li", { staticClass: "list-group-item" }, [
        _c("h6", { staticClass: "text-gray", staticStyle: { margin: "0" } }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("dashboard.outstandingDocuments")) +
              "\n    "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.loading
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center vertical-center h-100 py-5",
            },
            [
              _c("div", {
                staticClass: "spinner-border text-primary mb-5",
                staticStyle: { height: "5rem", width: "5rem" },
                attrs: { role: "status" },
              }),
            ]
          )
        : [
            _vm.outstandingDocs
              ? _vm._l(_vm.outstandingDocs, function (document) {
                  return _c(
                    "li",
                    {
                      key: document.applicationDocumentId,
                      staticClass: "list-group-item",
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-9" }, [
                          _c("h6", { staticClass: "text-gray bold" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(document.classification) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "text-primary view-comment file-doc clickable bold",
                              attrs: { href: "#/documents" },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$tc("dashboard.viewDocument", 2)) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  )
                })
              : _c("li", { staticClass: "list-group-item" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-9" }, [
                      _c("h6", { staticClass: "text-gray oblique bold" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("dashboard.errors.noOutstandingDocuments")
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }